import moment from 'moment';

/**
 * Is the webinar done.
 * @param {Date} startDate
 * @return {boolean}
 */
export default function isWebinarDone(startDate: Date): boolean {
  return moment(startDate).isBefore(moment());
}
